(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initHibaTabs() {
    var wrappers = document.querySelectorAll('.hiba-tabs-wrapper');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.hibaTabsReady === 'true') return;

      var tabButtons = wrapper.querySelectorAll('.hiba-tab-btn');
      var tabPanes = wrapper.querySelectorAll('.hiba-tab-pane');

      if (!tabButtons.length || !tabPanes.length) return;

      wrapper.dataset.hibaTabsReady = 'true';

      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var targetId = button.getAttribute('data-tab');
          var targetPane = wrapper.querySelector('#' + targetId);

          tabButtons.forEach(function (btn) {
            btn.classList.remove('hiba-tab-btn--active');
            btn.setAttribute('aria-selected', 'false');
          });

          tabPanes.forEach(function (pane) {
            pane.classList.remove('hiba-tab-pane--active');
          });

          button.classList.add('hiba-tab-btn--active');
          button.setAttribute('aria-selected', 'true');

          if (targetPane) {
            targetPane.classList.add('hiba-tab-pane--active');
          }
        });
      });
    });
  }

  function boot() {
    initHibaTabs();
    window.setTimeout(initHibaTabs, 300);
    window.setTimeout(initHibaTabs, 900);
  }

  ready(boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();

(function () {
  'use strict';

  if (window.__hibaCrossProductV3LoaderAdded) return;

  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? decodeURIComponent(match[1]) : '';
  var supported = handle === 'turkish-printed-rayon-viscose-jacquard-fabric' ||
    handle === 'turkish-printed-rayon-viscose-jacquard-fabric-kopya';

  if (!supported) return;
  window.__hibaCrossProductV3LoaderAdded = true;

  var current = document.currentScript;
  var currentSrc = current && current.src ? current.src : '';
  if (!currentSrc || currentSrc.indexOf('hiba-tabs.js') === -1) return;

  var script = document.createElement('script');
  script.src = currentSrc.replace('hiba-tabs.js', 'hiba-cross-product-v3.js');
  script.defer = true;
  script.dataset.hibaCrossProductV3Loader = 'true';
  document.head.appendChild(script);
})();
